var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _rect, _rect2, _circle8, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess2X(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 160,
    viewBox: "0 0 297 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.472 92.1882C98.6033 90.3951 96.5928 84.6489 96.3211 82L94.0797 84.8527C93.2646 88.928 98.9021 93.8863 101.823 95.856L104.472 92.1882Z",
    fill: "#14C69C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.446 7.79101C187.878 6.41979 186.313 2.02566 186.102 0L184.357 2.18148C183.723 5.29789 188.11 9.08951 190.384 10.5958L192.446 7.79101Z",
    fill: "#14C69C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225.668 75.7363C221.358 77.7784 217.253 75.5645 215.739 74.2023L215.905 76.9906C217.522 79.7293 223.32 79.6046 226.016 79.1999L225.668 75.7363Z",
    fill: "#14C69C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6732 93.2756C46.7067 97.9576 40.6338 97.5335 38.0931 96.7361L39.8277 99.9225C43.2491 102.282 50.0318 99.0629 52.9954 97.1585L50.6732 93.2756Z",
    fill: "#F5EC04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M285.027 129.719C280.514 125.561 281.191 119.511 282.094 117.005L278.838 118.606C276.338 121.926 279.271 128.837 281.051 131.877L285.027 129.719Z",
    fill: "#0D83FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.51 6.22595C104.504 9.77538 98.7271 7.85534 96.4643 6.45165L97.3527 9.96913C100.08 13.1047 107.45 11.6723 110.794 10.5641L109.51 6.22595Z",
    fill: "#FFBA09"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M284.115 69.0262C278.021 68.304 275.022 63.0063 274.284 60.4477L272.585 63.6532C272.507 67.8084 278.935 71.6865 282.159 73.1062L284.115 69.0262Z",
    fill: "#FFBA09"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8119 55.2197C38.7382 56.0944 34.4736 51.75 33.1004 49.4685L32.2861 53.0039C33.2828 57.0386 40.4944 59.1265 43.9756 59.666L44.8119 55.2197Z",
    fill: "#69D217"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8119 142.22C77.7382 143.094 73.4736 138.75 72.1004 136.469L71.2861 140.004C72.2828 144.039 79.4944 146.126 82.9756 146.666L83.8119 142.22Z",
    fill: "#0D83FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4933 60.2684C95.6496 63.6252 91.2956 63.3211 89.4741 62.7494L90.7177 65.0339C93.1707 66.7254 98.0335 64.4176 100.158 63.0522L98.4933 60.2684Z",
    fill: "#F7552D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M255.271 12.1727C254.391 17.0788 249.951 19.2552 247.841 19.7302L250.358 21.2623C253.724 21.526 257.178 16.5005 258.485 13.9548L255.271 12.1727Z",
    fill: "#F7552D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.217 127.354C195.338 132.26 190.898 134.437 188.788 134.912L191.305 136.444C194.67 136.708 198.124 131.682 199.431 129.136L196.217 127.354Z",
    fill: "#F7552D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M129.594 143.304C125.371 142.068 123.881 137.966 123.664 136.069L122.081 138.133C121.532 141.062 125.615 144.568 127.726 145.956L129.594 143.304Z",
    fill: "#F7552D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.4647,
    cy: 36.8815,
    r: 1.83388,
    fill: "#FF613D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.834,
    cy: 143.834,
    r: 1.83388,
    fill: "#FF613D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.121,
    cy: 40.5492,
    r: 1.83388,
    fill: "#FF613D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.213,
    cy: 36.8815,
    r: 1.83388,
    fill: "#FFB902"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 234.834,
    cy: 108.834,
    r: 1.83388,
    fill: "#FFB902"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.2079,
    cy: 113.09,
    r: 1.83388,
    fill: "#1AD0A9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.7187,
    cy: 157.918,
    r: 1.83388,
    fill: "#1AD0A9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.93066,
    y: 88.552,
    width: 3.66777,
    height: 4.0753,
    transform: "rotate(45.9872 2.93066 88.552)",
    fill: "#EFBE1D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 293.184,
    y: 94,
    width: 5.23571,
    height: 5.81745,
    transform: "rotate(45.9872 293.184 94)",
    fill: "#14C69C"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 81,
    r: 32,
    fill: "#81BF28",
    stroke: "#EDF9DD",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148.711 83.068L154.704 90.5117L173.039 72.7993",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess2X);
export default __webpack_public_path__ + "static/media/success@2x.c48a7423926629d9fc179dd6548d3717.svg";
export { ForwardRef as ReactComponent };